import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../redux/LoginSlice";
import { useDispatch } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { profile_information } from "redux/ProfileSlice";
import { decryptSecretKey } from "services/utils";
import * as yup from "yup";
import Wrapper from "layout/Wrapper/Wrapper";
import CustomInput from "ui/CustomInput/CustomInput";
import asset from "json/assets";
import CustomButton from "ui/CustomButton/CustomButton";
import validationText from "../../json/message/Validation";
import useNotiStack from "../../hooks/useNotistack";

import styles from "styles/pages/Login.module.scss";

const schema =  yup.object().shape({
  username: yup.string().trim().required(<p style={{fontSize:"15px"}}>{validationText.error.username}</p>),
  password: yup
    .string()
    .trim()
    .max(15)
    .required(<p style={{fontSize:"15px"}}>{validationText.error.enter_password}</p>),
});


export const Login = () => {
  let isAuth = decryptSecretKey();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { toastSuccess, toastError, toastInfo } = useNotiStack();
  // const {toastInfo} = useNotiStackInfo()
  const [loading, setLoading] = useState(false)
  // const login_status = useSelector((state) => state.LoginData);

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (!isAuth) return;
    
    const user = JSON.parse(localStorage.getItem("profile_data") || "{}");
    const mods = Array.isArray(user?.moduleArray) ? user.moduleArray : [];
    
    if (mods.length === 0) return;
    
    const target = pickLandingRoute(mods, { silent: true });
    navigate(target, { replace: true });
  }, [isAuth, navigate]);

  const pickLandingRoute = (mods = [], { silent = false } = {}) => {
    if (mods.includes(16)) return "/coursemap";
    if (mods.includes(22)) return "/drivingrange";
    if (mods.includes(23)) return "/heatmap";

    if (!silent) {
      toastError('You do not have relevant access rights. Please contact support.');
    }
  return "/NoAccess";
};

  const onSubmit = async (data) => {
    const loginData = {
      username: data.username.trim(),
      password: data.password.trim(),
    };
    setLoading(true)
    dispatch(login(loginData))?.then((res) => {
      if (res?.payload.data.Status === 1) {
        const userData = res?.payload?.data;
        const name = data?.username;
        const target = pickLandingRoute(userData.moduleArray || []);

        navigate(target, { replace: true });
        toastSuccess(res?.payload?.data?.ErrorMessage);
        setLoading(false)
      
        dispatch(
          profile_information({
            body: { id_adminuser: res?.payload?.data?.id_adminuser },
            user : {secretKey:userData.secretKey, userName:name}
          })
        );
      } else {
        if(res?.payload?.data?.Status === 216){
          toastError(res?.payload?.data?.ErrorDetails?.message);
          setLoading(false)
        }else{
          setLoading(false)
          toastError("Something went wrong")
        }
      }
    });
  };
const forgotPassword =()=>{
  toastInfo("Please contact to customer support")
}
  return (
    <div className={styles.Login}>
      <Wrapper isHeader={false}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={7} className={styles.mobD_none}>
              <div className={styles.lftimg}>
                <figure>
                  <img src={asset.loginBg} alt="" />
                </figure>
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <div className={styles.loginRight}>
                <div className={styles.bodysrcoll}>
                <div className={styles.logo}>
                  <Link to="/">
                    <img src={asset.logo} alt="" />
                  </Link>
                </div>
                <div className={styles.formSec}>
                  <div className={styles.formGroup}>
                    <Controller
                      control={control}
                      {...register("username")}
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          label="username*"
                          placeholder="Enter Username"
                          type="text"
                          name="username"
                          value={value}
                          onChange={onChange}
                          error={Boolean(errors?.username)}
                          helperText={errors?.username?.message} 
                          disabled={loading}
                        />
                      )}
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <Controller
                      control={control}
                      {...register("password")}
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          label="password*"
                          value={value}
                          type="password"
                          onChange={onChange}
                          placeholder="Enter Password"
                          error={Boolean(errors?.password)}
                          helperText={errors?.password?.message} 
                          disabled={loading}
                        />
                      )}
                    />
                  </div>
            {/* <BackdropLoader /> */}
                  <div className={styles.submitBtn}>
                    <CustomButton type="submit" disabled={loading}>
                   {(
                    // login_status?.status === "loading" ||
                    loading) ? (<>Logging in..</>):(<>Log in</>)}
                      </CustomButton>
                  </div>
                  <div className={styles.forgotPass}>
                    <Link onClick={forgotPassword}>Forgot Password?</Link>
                  </div>
                </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </form>
      </Wrapper>
    </div>
  );
};
